import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class ActionLogsV7MultiProductFeature implements IFlagFeature {
  name = Features.ACTION_LOGS_V7_MULTI_PRODUCT;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
